<template>
  <v-container class="subheading">
    <v-layout text-xs-center wrap>
      <v-flex md7 text-xs-left>
        <RecentPosts/>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
import RecentPosts from "../components/RecentPosts";
export default {
  name: "TechBlog",
  components: {
    RecentPosts
  },
  data: function() {
    return {
      //
    };
  }
};
</script>
<style>

</style>
